module.exports = __webpack_public_path__ + "img/直播数据字典.669a9dcf.png";